/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { NotificationSendForTypes, UserSettings, UserSettingsResource } from './user-settings.model';

export function mapUserSettingsResourceToUserSettings(resource: UserSettingsResource): UserSettings {
  const { _links, _embedded, ...userSettings } = resource;
  return <UserSettings>userSettings;
}

export function mapBooleanToNotificationSendFor(value: boolean): NotificationSendForTypes {
  return value ? NotificationSendForTypes.ALL : NotificationSendForTypes.NONE;
}

export function mapNotificationSendForToBoolean(value: NotificationSendForTypes): boolean {
  return value === NotificationSendForTypes.ALL;
}
